import { render } from "./CannonBoard.vue?vue&type=template&id=9d090398"
import script from "./CannonBoard.vue?vue&type=script&lang=js"
export * from "./CannonBoard.vue?vue&type=script&lang=js"

import "./CannonBoard.vue?vue&type=style&index=0&id=9d090398&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__